import PaymentMembersChangelogTable from './components/PaymentMembersChangelogTable';

const PaymentMembersChangelog = () => {
  return <PaymentMembersChangelogTable />;
};

export default PaymentMembersChangelog;
